<template>
  <div id="app">
    <Index />
    <router-view />
    <AboutUs />
  </div>
</template>
<script>
import Index from "./views/index.vue";
import AboutUs from "./views/AboutUs.vue";
export default {
  components: {
    Index,
    AboutUs,
  },
};
</script>
<style></style>
